import React, { Component } from 'react';
import PropTypes from 'prop-types';
import whiteBackground from '../wrapper-components/white-background';
import AttendeeSendInvitePageBody from './AttendeeSendInvitePageBody';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import _ from 'lodash';

class AttendeeSendInvitePageMain extends Component {
  constructor(props) {
    super(props);

    this.redirectToInbox = this.redirectToInbox.bind(this);
  }

  redirectToInbox() {
    const bookingId = _.get(this.props, 'booking.booking._id');
    this.props.dispatch(push(`/inbox/${bookingId}`));
  }

  render() {
    return (
      <div className="AttendeeSendInvitePageMain">
        <div className="content-container">
          <AttendeeSendInvitePageBody
            {...this.props}
            pageType="add_invites"
            cancelRedirect={this.redirectToInbox}
            showCancel
          />    
        </div>
      </div>
    );
  }
}

AttendeeSendInvitePageMain.propTypes = {
  dispatch: PropTypes.func
};

const mapStateToProps = ({ booking }) => ({ booking });

export default connect(mapStateToProps)(whiteBackground(AttendeeSendInvitePageMain));
